module.exports = __webpack_public_path__ + "media/src/images/zu_05keep_rules04-d78ffe388fd6912a489ac595a057d464.png";